<script lang="ts">
  import {getContext} from 'svelte';
  import {suppportConnectors} from '@/streams/wallet-connect';
  import Spin from '@/widgets/Spin.svelte';
  import {createActions} from './streams';
  import {openRestrictedIP} from '@/modules/register/restricted-ip';
  import '../access-google/access-styled.scss';

  export let scene;
  export let referralCode = '';
  export let fromType = '';
  export let width = 48;
  export let entrance = '';
  export let group: string | number = '';
  export let isOauth = false;
  export let iconInfo = {
    defaultIcon: 'https://img.phemex.com/v1/cef5dd17/transparent-metamask.svg',
    hoverIcon: 'https://img.phemex.com/v1/cef5dd17/transparent-metamask.svg',
    alt: 'icon',
    visibleTitle: false,
  }

  const LG = getContext('LG');
  const {submitConnect$, connectState$} = createActions(suppportConnectors.metaMask, fromType === 'popLogin', isOauth);
  let loading = false;

  $: loading = $connectState$ && $connectState$.loading;
  $: classProps = loading ? 'custom-loading' : '';

  export async function handleConnectClick(event) {
    // TODO 检测 IP
    const result = await openRestrictedIP({referralCode, LG, entrance});
    if (!result) {
      event.stopPropagation();
      return;
    }
    submitConnect$.next({scene, LG, referralCode, group});
  }
</script>

<section class="wallet-connect-box wallet-login">
  <div class="pr f16 df cp {classProps}" on:click={handleConnectClick} style="padding: 0">
    {#if !loading}
      <div class="df fdc jcc aic">
        <div class="img df jcc aic pr">
          <img width={width} height={width} data-replace-icon="false" src={iconInfo.defaultIcon} alt={iconInfo.alt} />
          <img width={width} height={width} class="white" data-replace-icon="false" src={iconInfo.hoverIcon} alt={iconInfo.alt} />
        </div>
        {#if iconInfo.visibleTitle}
          <div class="con mt12 f12 lh18 T3 sm:hidden">MetaMask</div>
        {/if}
      </div>
    {:else}
      <Spin style="background: none;transform: scale(0.7);" />
    {/if}
  </div>
</section>
